import { Type } from './enums';

export const DEFAULT_TOKENS_CLASS_NAME: Record<Type, string> = {
  [Type.LIGHT]: 'tguiAppearanceLight',
  [Type.DARK]: 'tguiAppearanceDark',
};
